import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src="https://customer-assets.emergentagent.com/job_wolf-eye/artifacts/128p77ad_LABANA%20Gold%20NO%20TEXT%2C%20TRANSPARENT%20-%20Copy.png" 
            alt="Labana Dynamics" 
            className="footer-logo"
          />
          <p className="footer-tagline">Advanced Defense Technology</p>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Navigation</h3>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/product" className="footer-link">Wolf Eye</Link>
            <Link to="/field-tests" className="footer-link">Field Tests</Link>
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Contact</h3>
          <div className="footer-contact">
            <div className="contact-item">
              <Mail size={16} />
              <a href={`mailto:${contactInfo.email}`} className="footer-link">{contactInfo.email}</a>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <span className="footer-link">{contactInfo.phone}</span>
            </div>
            <div className="contact-item">
              <MapPin size={16} />
              <span className="footer-link">{contactInfo.address}</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="footer-heading">Business Hours</h3>
          <p className="footer-text">{contactInfo.businessHours}</p>
          <p className="footer-text" style={{ marginTop: '20px', fontSize: '14px', opacity: 0.7 }}>
            ITAR Registered | NATO Certified
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {new Date().getFullYear()} Labana Dynamics OU. All rights reserved.
        </p>
        <div className="footer-legal">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <span className="footer-divider">|</span>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
          <span className="footer-divider">|</span>
          <Link to="/export-compliance" className="footer-link">Export Compliance</Link>
          <span className="footer-divider">|</span>
          <Link to="/admin/login" className="footer-link" style={{ opacity: 0.5 }}>Staff Access</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;